// extracted by mini-css-extract-plugin
export var typingIndicator = "_r1-0";